import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import InstagramComponent from "../InstagramComponent/InstagramComponent.component";
import Masonry from "react-masonry-css";
import { apiUrl } from "../../config/api";
import { COLD_START_LOADING_HINT } from "../../config/loading";

interface Ad {
  _id: string;
  id: number;
  user_id: string;
  title: string;
  description: string;
  country: string;
  state: string;
  city: string;
  instagram_post_url: string;
  keywords: string[];
  created_at: string;
}

const LocationDetails: React.FC = () => {
  const { country, state, city } = useParams<{
    country: string;
    state: string;
    city: string;
  }>();

  const [ads, setAds] = useState<Ad[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAds = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          apiUrl(
            `/api/ads/${encodeURIComponent(country!)}/${encodeURIComponent(state!)}/${encodeURIComponent(city!)}`,
          ),
        );
        const data = await response.json();

        if (data.success) {
          setAds(data.data);
        }
      } catch (error) {
        console.error("Error fetching ads:", error);
      } finally {
        setLoading(false);
      }
    };

    if (country && state && city) {
      fetchAds();
    }
  }, [country, state, city]);

  if (loading) {
    return (
      <div className="page-shell">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 mb-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-4">
              Details for {city}, {state}, {country}
            </h1>
          </div>
          <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
            <div className="flex flex-col items-center justify-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mb-4"></div>
              <p className="text-xl text-gray-600">Loading posts…</p>
              <p className="mt-2 max-w-md text-sm text-gray-500">
                {COLD_START_LOADING_HINT}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="page-shell">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 mb-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-4">
              Details for {city}, {state}, {country}
            </h1>
          </div>

          {ads.length === 0 ? (
            <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
              <p className="text-xl text-gray-600">No ads found for {city}.</p>
            </div>
          ) : (
            <Masonry
              breakpointCols={{ default: 3, 1024: 3, 768: 2, 640: 1 }}
              className="my-masonry-grid"
              columnClassName="my-masonry-grid_column"
            >
              {ads.map((ad) => (
                <InstagramComponent key={ad.id.toString()} ad={ad} />
              ))}
            </Masonry>
          )}
        </div>
      </div>
    </>
  );
};

export default LocationDetails;

/*
I need to run a query to get the ads for this location.

SQL example:
SELECT * FROM ads
WHERE country = 'USA' AND state = 'CA' AND city = 'San Francisco'

*/
